import Image from 'next/image';
import { VALUES } from './constants';
import reebeloLogo from '@/public/images/about/reebelo.svg';
import reebeloBadge from '@/public/images/about/reebelo-badge.svg';
import i18n from '@/settings/i18n';

const t = i18n.init('about');

const LeftSection = () => (
  <div className="relative flex w-full items-center justify-center bg-gray-700 p-5 py-20 text-white md:w-1/2 md:rounded-md">
    <div className="absolute left-5 top-5 h-10 w-10 lg:h-14 lg:w-14 xl:left-10 xl:top-10">
      <Image
        src={reebeloLogo}
        alt="Reebelo"
        className="h-full w-full"
        height={50}
        width={50}
      />
    </div>
    <div className="absolute bottom-5 right-5 h-10 lg:h-14 xl:bottom-10 xl:right-10">
      <Image
        src={reebeloBadge}
        alt="Reebelo Badge"
        className="h-full w-auto"
        height={50}
        width={50}
      />
    </div>
    <div className="w-full max-w-[400px] text-center text-xl md:text-2xl ">
      {t`We're a trusted, global marketplace - connecting`}{' '}
      <b>{t`reliable vendors`}</b>{' '}
      {t`to customers looking for eco-friendly products. Our promise - always a`}{' '}
      <span className="text-teal-500">{t`better deal with the best prices.`}</span>
    </div>
  </div>
);

const RightSection = () => (
  <div className="w-full space-y-5 p-5 sm:p-8 md:w-1/2 md:p-0">
    {VALUES.map((value) => (
      <div className="rounded-md bg-white p-5 md:p-8">
        <div className="flex items-center gap-2">
          <div className="h-7 w-7">
            <Image
              src={value.icon}
              alt={t(value.title)}
              className="h-full w-full"
              height={50}
              width={50}
            />
          </div>
          <h3 className="text-base font-bold">{t(value.title)}</h3>
        </div>
        <p className="mt-2 text-sm">{value.description(t)}</p>
      </div>
    ))}
  </div>
);

const Trust = () => (
  <section className="reebelo-container flex flex-col-reverse p-0 md:flex-row md:gap-5 md:p-8">
    <LeftSection />
    <RightSection />
  </section>
);

export default Trust;
